<template>
  <transition name="transition" appear mode="out-in">
    <a-result
      status="error"
      title="Falló la solicitud"
      sub-title="Por favor, volvé a intentarlo nuevamente más tarde."
    >
      <template #extra>
        <a-button key="console" type="primary" @click="onRetry">
          Reintentar
        </a-button>
        <a-button key="buy">
          <a href="mailto:trafico@jipink.com">Contactar</a>
        </a-button>
      </template>
    </a-result>
  </transition>
</template>
<script>
export default {
  methods: {
    onRetry() {
      this.$router.push('/')
    },
  }
};
</script>
<style scoped>
.transition-enter-active, .transition-leave-active {
  transition: opacity .8s, transform .8s;
}
.transition-enter {
  opacity: 0;
  transform: translateY(20px)
}
.transition-leave-to {
  opacity: 0;
  transform: translateY(-20px)
}
</style>
